<template>
  <div class="">
    <sidebar-menu
      :menu="menu"
      width="16vw"
      :collapsed="collapsed"
      :hideToggle="true"
      :theme="selectedTheme"
      :show-one-child="true"
      @item-click="onItemClick">
      <template slot="header">
        <div class="row m-0 pl-2 pt-2 headerElementStyle customSideBG">
          <div class="col-9">
            <h2 class="text-white">{{sideBarTitle}}</h2>
          </div>
          <div class="col-3">
            <!--<base-button
              size="sm"
              type="light"
              class="btn-customgray"
              icon="ni ni-curved-next"
              v-on:click="openModalClicked"
            >
            </base-button>-->
          </div>
        </div>

      </template>
    </sidebar-menu>

    <!-- <modal :show.sync="openModal">
      <template slot="header">
        <h3 class="modal-title" id="formPickerModal"><i class="ni ni-bus-front-12"></i>Portfolio</h3>
      </template>
      <div class="row">
        <div class="col">
          <select class="custom-select" name="" v-model="selectedLine" :disabled="lines.length>0?false:true">
            <option value="0" selected disabled>Select Line</option>
            <option v-for="(item, index) in lines" :key="index" :value="item.code">{{item.title}}</option>
          </select>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" v-on:click="closeModalClicked">Close</base-button>
      </template>
    </modal> -->
    <modal :show.sync="openModal">
      <template slot="header">
        <h3 class="modal-title" id="formPickerModal"><i class="ni ni-bus-front-12"></i> Portfolio</h3>
      </template>
      <div class="row">
        <div class="col">
          <select class="custom-select" name="" v-model="selectedPortfolio" :disabled="lines.length>0?false:true">
            <option value="0" selected disabled>Select Portfolio</option>
            <option v-for="(item, index) in portfolios" :key="index" :value="item.code">{{item.title}}</option>
          </select>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" v-on:click="closeModalClicked">Close</base-button>
      </template>
    </modal>
  </div>

</template>
<script>
import modal from "@/components/Modal";
  export default {
    name: "DashboardNavbar",
    components: {
      modal
    },
    props: {
      menu: Array,
      sideBarTitle: String
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        collapsed: false,
        // selectedTheme: 'white-theme',
        selectedTheme: '',
        openModal: false,
        selectedLine: "0",
        selectedPortfolio: "",
        currentSelectedProject: "",
        currentSelectedSubCategory: ""
      };
    },
    computed: {
      lines: {
        get() {
          return this.$store.state.sideBarStore.lines
        }
      },
      portfolios: {
        get() {
          return this.$store.state.sideBarStore.portfolios
        }
      },
      selectedProjects: {
        get() {
          return this.$store.state.sideBarStore.selectedProjects
        }
      },
      selectedCategories: {
        get() {
          return this.$store.state.sideBarStore.selectedCategories
        }
      },
      selectedZone: {
        get() {
          return this.$store.state.sideBarStore.selectedZone
        }
      }
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      onItemClick(event, item) {
        const current = this
        event.preventDefault();

        if(current.selectedProjects.includes(item.title)){
          console.log(item);
          current.$store.commit("sideBarStore/setCurrentSelectedProject",item.title)
        }
        else {
          if(current.selectedCategories.includes(item.title)){
            // item.class = "childElementStyle"
            item.class = "childElementStyle text-active-color"

            current.$store.commit("sideBarStore/setCurrentSelectedSubCategory",item.title)
            var currentZoneTab = current.$store.state.sideBarStore.projectTabs.filter(obj=>obj.zoneCode == current.selectedZone.code)[0];
            var currentSelectedProjectTab = currentZoneTab.items.filter(obj=>obj.category == item.title)[0]
            console.log(currentZoneTab);
            console.log(item.title);
            console.log(currentSelectedProjectTab);
            current.$store.commit("sideBarStore/setCurrentSelectedProjectTab",currentSelectedProjectTab)
            // current.$store.commit("sideBarStore/setSelectedProjects",current.selectedPortfolio);
            console.log(item);
          }

        }
        // console.log(current.$store.state.sideBarStore.projectTabs);
        // console.log(current.$store.state.sideBarStore.projectTabs.filter(obj=>obj.zoneCode == current.selectedZone.code)[0]);

        // current.$store.state.sideBarStore.projectTabs.forEach((projectTab, projectIndex)=>{
        //   console.log("loop");
        //   if()
        //   console.log(projectTab[current.selectedZone.code]);
        //   console.log(projectIndex);
        // })

        // console.log(item.title);
        // current.currentSelectedSubCategory = item.title
        // current.$store.commit("sideBarStore/setCurrentSelectedSubCategory",item.title);
      },
      openModalClicked: function() {
        this.openModal = true;
      },
      closeModalClicked: function() {
        this.openModal = false;
      },
    },
    watch: {
      // currentSelectedSubCategory: function(){
      //   const current = this
      //   current.$store.commit("sideBarStore/setCurrentSelectedSubCategory",current.currentSelectedSubCategory)
      // },
      // currentSelectedProject: function(){
      //   const current = this
      //   console.log(current.currentSelectedProject);
      //   current.$store.commit("sideBarStore/setCurrentSelectedProject",current.currentSelectedProject)
      // },
      selectedLine: function(){
        const current = this
        console.log(current.selectedLine);
        current.$store.commit("sideBarStore/setSelectedLine",current.selectedLine);
        current.$store.commit("sideBarStore/setSelectedStations",current.selectedLine);
        // current.$store.dispatch("sideBarStore/setSelectedLine",current.selectedLine);

      },
      selectedPortfolio: function(){
        const current = this
        console.log(current.selectedPortfolio);
        current.$store.commit("sideBarStore/setSelectedPortfolio",current.selectedPortfolio);
        current.$store.commit("sideBarStore/setSelectedProjects",current.selectedPortfolio);
        // current.$store.dispatch("sideBarStore/setSelectedLine",current.selectedLine);

      }
    },
    mounted() {
      const current = this
      var currentZoneTab = current.$store.state.sideBarStore.projectTabs.filter(obj=>obj.zoneCode == current.selectedZone.code)[0];
      var currentSelectedProjectTab = currentZoneTab.items[0]
      console.log(currentZoneTab);
      current.$store.commit("sideBarStore/setCurrentSelectedProjectTab",currentSelectedProjectTab)
    }
  };
</script>
<style>
/* .v-sidebar-menu {
  top: 91px !important;
  left: 110px !important;
  background-color:  #2d3339 !important;
}
.v-sidebar-menu .vsm--dropdown .vsm--list {
    background-color: #2d3339 !important;
} */
.main-content {
    position: fixed !important;
    margin-left: 110px !important;
    width: 94.5%;
    width: -moz-available;          /* WebKit-based browsers will ignore this. */
    width: -webkit-stretch;  /* Mozilla-based browsers will ignore this. */
    width: stretch;
    /* margin-left: 460px !important; */
    /* 350 */
    /* margin-left: 0 !important; */
}
.v-sidebar-menu {
    /* position: relative !important;
    height: 88.9vh !important; */
    position: fixed !important;
    top: inherit !important;
    left: inherit !important;
    height: 90.3vh;
}
.text-active-color span{
  color: #5b9bd5 !important;
}

.customSideBG {
  background-color: #203864 !important;
}
</style>
